var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.result != undefined)?_c('div',{staticClass:"bet-res"},[_c('transition',{attrs:{"name":"fade"}},[_c('b-row',{staticClass:"result-row"},[_c('b-col',[_c('img',{attrs:{"src":_vm.imgPath}})])],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }